module.exports = {
	Accelerometer: require("./Accelerometer").default
}